<template>
	<div class="header">
		<div class="container-fluid">
			<!-- Hearer  -->
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Master Data</li>
								<li class="breadcrumb-item">Project Tags</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card mt-5">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title">Project Tags</h4>
					<!-- Button -->
					<b-button v-if="isCreate" v-b-modal.modal-1 variant="primary" @click="createData">
						<span class="fe fe-plus mr-2"></span>
						Add Tag
					</b-button>
				</div>
				<div class="card-body">
					<div class="d-flex justify-content-end mb-3">
						<input type="text" class="form-control w-25" placeholder="Search" v-model="body.search" @input="search()" />
					</div>
					<vue-good-table
						:line-numbers="true"
						:columns="listColumns"
						:rows="list.data"
						:sort-options="{
							enabled: true,
						}"
						:total-rows="list.totalItems"
						:pagination-options="{
							enabled: true,
							perPage: body.pageSize,
						}"
						style-class="vgt-table border-0 table"
						@on-page-change="onPageChange"
						@on-per-page-change="onPageChange"
						@on-sort-change="onSortChange"
					>
						<!-- Loading -->
						<div slot="emptystate" class="text-center font-size-14">No data available</div>
						<!-- Custom Rows -->
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'total_po'">
								Rp. {{ convertNumber(parseFloat(props.row.opex_value) + parseFloat(props.row.capex_value)) }}
							</span>
							<!-- Table Action -->
							<span v-else-if="props.column.field == 'action'">
								<b-button class="no-wrap btn-pill" variant="secondary" size="sm" @click="detailData(props.row)">
									<span class="fe fe-search"></span>
								</b-button>
								<b-button
									v-if="isUpdate"
									class="no-wrap btn-pill ml-2"
									variant="warning"
									size="sm"
									@click="editData(props.row)"
								>
									<span class="fe fe-edit"></span>
								</b-button>
								<b-button
									v-if="isDelete"
									class="no-wrap ml-2"
									variant="danger"
									style="margin-left: 5px"
									size="sm"
									@click="deleteData(props.row.id)"
								>
									<span class="fe fe-trash-2"></span>
								</b-button>
							</span>
						</template>
						<template slot="pagination-bottom" slot-scope="props">
							<div class="d-flex justify-content-end">
								<div>
									<b-pagination
										:value="1"
										:total-rows="list.totalItems"
										:per-page="body.pageSize"
										first-number
										last-number
										align="right"
										prev-class="prev-item"
										next-class="next-item"
										class="mr-3 mb-4 mt-0"
										@input="(value) => props.pageChanged({ currentPage: value })"
									>
									</b-pagination>
								</div>
							</div>
						</template>
					</vue-good-table>
				</div>
			</div>
		</div>
		<b-modal id="modal-form" hide-footer :title="isAdd ? 'Add Tag' : 'Edit Tag'">
			<form @submit.prevent="submitForm()">
				<div class="form-group">
					<label>Name <span class="text-danger">*</span></label>
					<input name="name" type="text" required class="form-control" v-model="payload.name" aria-required="true" />
					<span v-if="errorsField.name" class="text-danger">{{ errorsField.name }}</span>
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea rows="2" cols="1" class="form-control" v-model="payload.description"></textarea>
				</div>
				<b-button type="submit" variant="primary" class="ml-1"> Save </b-button>
			</form>
		</b-modal>
		<ModalDetailProjectTag ref="modal-detail-tag" :metaData="selectedRow" />
	</div>
</template>

<script>
import ModalDetailProjectTag from './modalDetail.vue';
import index from 'vuex';
import axiosIns from '@/api/axios';

export default {
	name: 'ListUser',
	components: { ModalDetailProjectTag },
	computed: {
		list() {
			return this.$store.getters['projectTag/list'];
		},
	},
	data() {
		return {
			body: {
				pageNumber: 1,
				pageSize: 10,
				search: '',
				field: 'id',
				order: 'desc',
			},
			payload: {
				name: '',
				description: '',
			},
			errorsField: {},
			id: '',
			isAdd: true,
			isLoading: false,
			listColumns: [
				{
					label: 'Tag Name',
					field: 'name',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Description',
					field: 'description',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Total PO Opex',
					field: (field) => `Rp. ${this.convertNumber(field.opex_value)}`,
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold wrap-col',
					tdClass: 'wrap-col wrap-col--desc color-secondary align-middle',
				},
				{
					label: 'Total PO Capex',
					field: (field) => `Rp. ${this.convertNumber(field.capex_value)}`,
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Total Capex+Opex',
					field: 'total_po',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Action',
					field: 'action',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold text-center',
					tdClass: 'no-wrap color-secondary align-middle text-center',
				},
			],
			isRead: false,
			isCreate: false,
			isUpdate: false,
			isDelete: false,
			debounceSearch: null,
			selectedRow: {},
		};
	},

	async mounted() {
		await this.checkPermission();
		await this.getList();
	},
	methods: {
		async checkPermission() {
			const roleName = localStorage.getItem('roles');
			const roleId = await axiosIns.get('/master-role/find-name?name=' + roleName);
			const menuId = await axiosIns.get('/master-menu/find-link?link=' + this.$route.path);
			const payloadPermission = {
				role_id: roleId.data.data[0]?.id || null,
				menu_id: menuId.data.data[0]?.id || null,
			};
			const checkAuth = await axiosIns.post('/master-role/check-permission', payloadPermission);
			if (checkAuth.data.data?.authorization) {
				this.isRead = checkAuth.data.data?.authorization.includes('read');
				this.isCreate = checkAuth.data.data?.authorization.includes('create');
				this.isUpdate = checkAuth.data.data?.authorization.includes('update');
				this.isDelete = checkAuth.data.data?.authorization.includes('delete');
			}
		},
		convertNumber(dat) {
			const number = dat || 0;
			return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
		},
		search() {
			if (this.debounceSearch) {
				clearTimeout(this.debounceSearch);
			}
			this.debounceSearch = setTimeout(() => {
				this.getList();
			}, 500);
		},
		getList() {
			this.$store.dispatch('projectTag/GET_LIST', this.body);
		},
		async submitForm() {
			try {
				if (this.isAdd) {
					await this.$store.dispatch('projectTag/CREATE', this.payload);
				} else {
					await this.$store.dispatch('projectTag/UPDATE', this.payload);
				}
				this.getList();
				this.$bvModal.hide('modal-form');
				this.$swal('Saved', 'Your input has been saved', 'success');
			} catch (e) {
				this.$swal('Error', e?.response?.data?.error || 'Error while save data', 'error');
			}
		},
		async detailData(row) {
			await this.$store.dispatch('projectTag/GET_DETAIL', row.id);
			this.$bvModal.show('modal-detail-tag');
			this.selectedRow = row;
		},
		createData() {
			this.isAdd = true;
			this.payload = {
				name: '',
				description: '',
			};
			this.$bvModal.show('modal-form');
		},
		editData(data) {
			this.isAdd = false;
			this.payload = {
				id: data.id,
				name: data.name,
				description: data.description,
			};
			this.$bvModal.show('modal-form');
		},
		deleteData(id) {
			this.$swal({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('projectTag/DELETE', id)
						.then((resp) => {
							this.getList();
							this.$swal('Deleted!', 'Tag has been deleted', 'success');
						})
						.catch((resp) => {
							this.$swal('Error', resp?.response?.data?.error || 'Error while delete data', 'error');
						});
				}
			});
		},
		// filter
		sorting() {
			this.getList();
		},
		// Pagination
		onPageChange(payload) {
			this.body.pageSize = payload.currentPerPage;
			this.body.pageNumber = payload.currentPage;
			this.getList();
		},
		onSortChange(params) {
			let sort1 = params[0].field;
			let sort2 = params[0].type;
			this.body.field = sort1;
			if (sort2 == 'none') {
				this.body.order = '';
			} else {
				this.body.order = sort2;
			}
			this.getList();
		},
		searchData() {
			this.isLoading = true;
			if (this.paramName !== null && this.paramName !== '') {
				this.body.name = this.paramName;
			}
			this.getList();
		},
		validateForm() {
			this.errorsField = {};
			if (!this.payload.name) {
				this.errorsField.fullname = 'Name is required.';
			}
		},
	},
};
</script>
